module.exports = __webpack_public_path__ + "static/control_de_sistema_rpm-e51553e4560c668d9d43176354648178.png";